import ACTION_TYPES from '../../constants/actionTypes';
import get from 'lodash/get';

export default {
  newClient(state = [], action) {
    switch (action.type) {
      case ACTION_TYPES.CREATE_QUOTE_SUCCESS:
        return {
          client_type: get(action, 'payload.application.client.client_type'),
          person: {
            ...get(action, 'payload.application.client'),
          },
        };
      default:
        return state;
    }
  },
};
